import Vue from 'vue'
import posthog from 'posthog-js'

const isDisabled = process.env.VUE_APP_DISABLE_POSTHOG == 'true'
export default {
  install: function (vue, router, store) {
    Vue.prototype.$track = function () {
      console.log('Track called', process.env.VUE_APP_ENV_NAME, process.env.VUE_APP_ENV_NAME == 'local',arguments)
      if (isDisabled) {
        if (process.env.VUE_APP_ENV_NAME == 'local') console.log('Track capture supressed', arguments)
        return
      }
      posthog.capture(...arguments)
    }
    if (isDisabled) {
      console.warn('Tracking disabled')
      return
    }
    const setIdentity = (user) => {
      if (!user) return //tood: any deIntentify with posthog

      const { email, first_name, last_name, id, practice } = user
      if (id) {
        posthog.identify(id)
      }

      posthog.people.set({
        email,
        first_name,
        last_name,
        practice: practice?.id,
        practice_name: practice?.name,
        has_subscription: practice?.has_active_subscription,
        specialty: practice?.specialty,
      })
    }
    store.watch(
      (state) => state.auth.user,
      (user, oldUser) => {
        const isOldUser = !!Object.keys(oldUser).length
        const isNewUser = !!Object.keys(user).length
        const isLogout = isOldUser && !isNewUser
        if ((isOldUser && isNewUser && oldUser.id != user.id) || isLogout) {
          posthog.reset()
        }
        setIdentity(user)
      }
    )
    store.subscribeAction((action, state) => {
      if (action.type === 'practices/addToNetwork') {
        try {
          posthog.capture('$addedPractice', { practice: action.payload })
        } catch (e) {}
      }
    })
    router.afterEach((to, from) => posthog.capture('$pageview'))

    // const exisitingVueErrorHandler = vue.config.errorHandler
    // vue.config.errorHandler = (e, vm, info) => {
    //   const { message, filename, lineno, colno, error } = e
    //   try {
    //     posthog.capture('$frontendException', {
    //       message,
    //       filename,
    //       lineno,
    //       colno,
    //       error,
    //       info
    //     })
    //   } catch (err) {}
    //   if (exisitingVueErrorHandler) exisitingVueErrorHandler(e, vm, info)
    // }
    // window.addEventListener('error', e => {
    //   const { message, filename, lineno, colno, error } = e
    //   try {
    //     posthog.capture('$frontendException', {
    //       message,
    //       filename,
    //       lineno,
    //       colno,
    //       error
    //     })
    //   } catch (err) {}
    // })           

    console.log('Initializing PostHog', process.env.VUE_APP_PUBLIC_POSTHOG_KEY, process.env.VUE_APP_PUBLIC_POSTHOG_HOST)
    posthog.init(process.env.VUE_APP_PUBLIC_POSTHOG_KEY, {
      api_host: process.env.VUE_APP_PUBLIC_POSTHOG_HOST,
      loaded: (ph) => {
        if (isDisabled) return
        setIdentity(store.state?.auth?.user)
        store.dispatch('auth/setTrackingLoaded') //todo: this looks removable all togethr
      },
      autocapture: !isDisabled,
      disable_session_recording: isDisabled,
    })
    posthog.register({
      environment: process.env.NODE_ENV,
      version: process.env.VUE_APP_VERSION + '-' + process.env.VUE_APP_BUILD_VERSION,
    })
    if (process.env.VUE_APP_ENV_NAME === 'local') posthog.debug()
    Vue.prototype.$posthog = posthog
  },
}
